import routes from '@/constants/routes'
import CtaLink from '@/components/ui/cta-link'
import { useTranslations } from '@/utils/locale'
import colors from '@/constants/colors'
import { cx } from '@/utils/strings'

export default function DemosCtaCard({ className }): JSX.Element {
  const { t } = useTranslations()
  return (
    <div className={cx('p-8 [h2]:m-0 bg-secondary-50 rounded-2xl ', className)}>
      <h3 className="text-2xl">{t('Live and On-Demand Demonstrations')}</h3>
      <p>{t('Save your seat for a business demo and Q&A or watch an on-demand demo today.')}</p>
      <CtaLink style="Arrow Link" to={routes.weekly}>
        {t('Live demo registration')}
      </CtaLink>
      <br />
      <CtaLink to="/resources/videos/enterprise-demo/">{t('Watch it on demand')}</CtaLink>
    </div>
  )
}
